type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

export const META_PIXEL_ID = "1455801989768520";

/** Carga el Meta Pixel (código oficial) y registra el PageView. Se ejecuta una sola vez. */
export function initMetaPixel() {
  if (typeof window === "undefined" || window.fbq) return;

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  } as Fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  const first = document.getElementsByTagName("script")[0];
  if (first?.parentNode) {
    first.parentNode.insertBefore(script, first);
  } else {
    document.head.appendChild(script);
  }

  fbq("init", META_PIXEL_ID);
  fbq("track", "PageView");
}

/** Envía un evento estándar de Meta */
export function trackMetaEvent(event: string, params?: Record<string, unknown>) {
  window.fbq?.("track", event, params);
}

export type CheckoutTracking = {
  value: number;
  contentName: string;
  contentId: string;
};

/** Registra InitiateCheckout con el valor del producto */
export function trackInitiateCheckout({ value, contentName, contentId }: CheckoutTracking) {
  trackMetaEvent("InitiateCheckout", {
    value,
    currency: "ARS",
    content_name: contentName,
    content_ids: [contentId],
    content_type: "product",
    num_items: 1,
  });
}
